import { Controller } from "@hotwired/stimulus";

// Sits on the layout's `page-content` Turbo Frame, which carries
// data-turbo-action="advance" so every navigation into it moves the URL along.
// After such a navigation Turbo leaves the frame's `src` pointing at the page
// just loaded. On back/forward Turbo restores the previous page and the frame
// reloads that stale `src`, re-applying the navigation the member just undid —
// the URL goes back but the content doesn't. Turbo reads `src` to start the
// promoted visit, so drop it as soon as that visit starts (turbo:visit) —
// before the URL changes — and let the URL be the only source of truth.
//
// Turbo never updates the tab title on a frame navigation, so each page carries
// its title inside the frame (the `title` target) and it is copied to the tab
// whenever a new one arrives: an in-page link, back/forward restoring the frame,
// or a stream that swaps the page. Other frames (modals, inline rows) carry none.
// The reminder alert count for the nav badges travels the same way.
export default class extends Controller {
  static targets = ["title", "alertCount"];

  connect() {
    this.clearSource = this.clearSource.bind(this);
    document.addEventListener("turbo:visit", this.clearSource);
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.clearSource);
  }

  clearSource() {
    this.element.removeAttribute("src");
  }

  titleTargetConnected(element) {
    document.title = element.dataset.pageTitle;
  }

  // The member's reminder alert count rides in the frame the same way (LI-296): every page, and the
  // stream after a dismiss, carries it, and the nav badges outside the frame follow it.
  alertCountTargetConnected(element) {
    const count = Number(element.dataset.alertCount) || 0;
    document.querySelectorAll("[data-reminder-badge]").forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }
}
